import { ButtonColor, ButtonTextColorMap } from "@/common/enum/button-color";
import { Button } from "flowbite-react";
import { useState } from "react";
import { RefreshOutlineIcon } from "../icon/RefreshOutlineIcon";
import { Footnote12Description } from "../typography/Footnote12Description";

interface Props {
  color: ButtonColor;
  children: React.ReactNode;
  handleClick?: React.MouseEventHandler<HTMLButtonElement>;
}

export const RefreshButton: React.FC<Props> = ({
  color,
  children,
  handleClick,
}) => {
  const [isFocused, setIsFocused] = useState(false);

  const handleFocus = () => {
    setIsFocused(true);
  };

  const handleBlur = () => {
    setIsFocused(false);
  };

  return (
    <Button
      color={color}
      size="xs"
      className="flex justify-center items-center p-0"
      onClick={handleClick}
      onFocus={handleFocus}
      onBlur={handleBlur}
    >
      <div className="flex items-center">
        <RefreshOutlineIcon
          size={14}
          color={isFocused ? "text-white" : ButtonTextColorMap[color]}
        />
      </div>
      <Footnote12Description className="ml-[4px] mt-[2px]">
        {children}
      </Footnote12Description>
    </Button>
  );
};
